import React from "react";
import "./search.css";

function Quantity() {
  return (
    <div className="container">
      <div className="row QuantityHeader">
        <div className="col-12">
          <span className="QuantityTitle ">Quantity to be achived [20]</span>
        </div>
        <div className="col-6">
            <div className="row underline">
                <div className="col-6 Qutycont">
                    <span>Quantity Achived : </span>
                </div>
                <div className="col-3 Qutycont">
                    <span>15</span>
                </div>
                <div className="col-3 Qutycont DEnd">
                    <span>Nos</span>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default Quantity;
